<div class="!bg-[#F0F0F0]">
  <div class="p-6 bg-white">
    <div class="text-[20px] font-bold mb-4">GENERAL RESPONSE</div>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <div *ngFor="let item of rfiData">
        <div class="font-semibold">{{ item.label }}</div>
        <div [ngClass]="{'pending': item.label === 'Status' && item.value === 'Open'}">
          {{ item.value }}
        </div>
      </div>
    </div>
  </div>
</div> 
<!-- link -->
<div class="!bg-[#F0F0F0]">
  <div class="p-6 bg-white mt-[20px] rounded">
    <div class="text-[20px] font-bold mb-4">LINKS</div>
    <div></div>

  </div>
  <!-- Button -->
  <div class="flex justify-end"> 
    <button
      class="bg-[#e76b3f] text-white px-4 py-2 !my-[25px] !h-[38px] rounded hover:bg-orange-600"
    >
      Return to RFI Manager's Court
    </button>
  </div>
</div>
